<template>
  <v-footer
    class="justify-center"
    color="grey darken-3"
    height="156"
    inset
  >
    <div class="text-center">
      <v-btn
        v-for="(idata, i) in icons"
        :key="i"
        class="ma-1"
        icon
        :href="idata.url"
        target="_blank"
      >
        <v-icon v-text="idata.icon" />
      </v-btn>

      <div class="my-3" />

      <div>Copyright &copy; {{ date }}&nbsp;<strong>Paul Lowe Studios</strong></div>
    </div>
  </v-footer>
</template>

<script>
  export default {
    name: 'CoreFooter',

    data: () => ({
      date: (new Date()).getFullYear(),
      icons: [
        { icon: 'mdi-twitter', url: 'https://twitter.com' },
        { icon: 'mdi-facebook', url: 'https://facebook.com' },
      ],
    }),
  }
</script>
